import '@fortawesome/fontawesome-free/css/all.css'
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#6d6d5f",
                secondary: "#C93128",
                third: "#003156",
                fourth: "#3d3d3d",
                card_header: "#e2e2e2",
                card_body: "#f4f4f4",
                button: "#404040"
            },
            dark: {
                primary: "#6d6d5f",
                secondary: "#C93128",
                third: "#003156",
                fourth: "#3d3d3d",
                card_header: "#e2e2e2",
                card_body: "#f4f4f4",
                button: "#404040"
            }
        }
    },
    breakpoint: {
        thresholds: {
            mobile: 450,
            xs: 600,
            sm: 960,
            md: 1264,
            lg: 1904,
        },
    }
});
